import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Page404() {
    return (
        <>
            <div className="navbarrrr">
                <Navbar />
            </div>

            <section className="position-relative bg-white text-dark d-flex flex-column flex-lg-row align-items-center justify-content-center vh-100 overflow-hidden px-3">

                {/* Image Section */}
                <div className="col-12 col-lg-6 text-center mt-5 mb-lg-0">
                    <img
                        src="images/404error.png"
                        className="img-fluid w-75 mt-5"
                        alt="404 error"
                    />
                </div>

                {/* Text Section */}
                <div className="col-12 col-lg-6 text-center text-lg-start">
                    <h1 className="display-5 fw-bold">Oh No!</h1>
                    <h4 className="h5 mb-4">
                        Looks like this page unraveled. Let’s get back to the Homepage.
                    </h4>
                    <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start">
                        <Link to="/" className="btn btn-danger text-light me-sm-3 mb-2 mb-sm-0">
                            Return to Homepage
                        </Link>
                        <Link to="/Contact" className="btn btn-light">
                            Contact us Now
                        </Link>
                    </div>
                </div>
            </section>

            <div className="row m-0 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>
        </>
    );
}
